'use client';
import { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';

export function DeviceRedirect() {
  const router = useRouter();
  const pathname = usePathname();
  const lastPathname = pathname.split('/').pop();

  useEffect(() => {
    // 如果是 download 或 refer 页面，不进行重定向
    if (lastPathname === 'download' || lastPathname === 'refer') {
      return;
    }

    // Check user-agent for mobile indicators
    const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);

    if (isMobile) {
      router.push('/download');
    }

    // No need for resize listener or cleanup for user-agent check
  }, [router, lastPathname]);

  return null;
}
